import { http } from 'utils'

// Calendar mutation imports.
import { SET_CALENDAR_BOOKINGS } from 'vx/mutations'

// Calendar state.
const state = {
  bookings: []
}

// Calendar state getters.
const getters = {}

// Calendar actions.
const actions = {
  getCalendarBookings ({ commit }, params = {}) {
    return http.get('calendar', { params })
      .then((response) => {
        commit(SET_CALENDAR_BOOKINGS, response.data)
      })
  }
}

// Calendar state mutations.
const mutations = {
  [SET_CALENDAR_BOOKINGS] (state, bookings) {
    state.bookings = bookings
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
